import { T } from '../../i18n';
import { Services } from '../../services/index';
import { CurrentState } from '../../state/page.state';
import { CollectionMoveToJobModal } from '../collection.move.modal/collection.move.job.modal';

export const CollectionMoveToJobCtrl = {
	canMove(): boolean {
		const userProfile = Services.UserProfile.get(Services.User.current.objectId);
		const canUserMove =
			Services.UserProfile.isDepartmentAdmin(userProfile) || Services.UserProfile.isDepartmentDataAdmin(userProfile);
		return canUserMove;
	},

	showMoveModal(): void {
		const collections = CurrentState.Tag.collections;
		const modal = new CollectionMoveToJobModal(
			{
				title: T.COLLECTION_MOVE_JOB_TITLE,
				confirm: T.COLLECTION_MOVE,
				success: {
					key: T.COLLECTION_MOVE_SUCCESS,
					attrs: {
						count: collections.length,
					},
				},
			},
			collections
		);

		modal.open();
	},
};
